// Auto-generated by scripts/generate-env.cjs. Do not edit manually.
export const environment = {
  apiBaseUrl: 'https://ovp-api-testing.eyeonapp.com/api',
} as const;
